import React, { useEffect, useContext } from "react";
import LanguageContext from "context/context-language";
let iconos = [
    require("../assets/img/productos/keep_running/modem.png"),
    require("../assets/img/productos/keep_running/camara.png"),
    require("../assets/img/productos/keep_running/aire.png"),
    require("../assets/img/productos/keep_running/alertas.png"),
    require("../assets/img/productos/keep_running/reinicio.png"),
    require("../assets/img/productos/keep_running/onoff.png")
]
let textos = {
    es: [
        {
            seccion1: [
                "Tu hogar siempre conectado, estés donde estés",
                "Con nuestro enchufe inteligente, puedes reiniciar y controlar tus dispositivos clave en cualquier momento y desde cualquier lugar.",
                "¿Qué puedes controlar?",
                [
                    "Cámaras de seguridad: asegúrate de que siempre estén activas.",
                    "Aire acondicionado: evita fallas y mantén el control a distancia.",
                    "Wifi: reinicia tu red en segundos, sin moverte",
                    "Luces o lámparas: simula presencia en casa cuando estás fuera."
                ]
            ],
            seccion2: [
                "¿Cómo funciona?",
                "Solo conecta tus equipos al enchufe inteligente y desde la app podrás:",
                [
                    "Vigilar que tu internet está funcionando",
                    "Asegurar que tus cámaras de seguridad  están online",
                    "Vigilar que la temperatura y humedad son correctas ",
                    "Recibir alertas si algo deja de funcionar",
                    "Programar reinicios automáticos",
                    "Encender o apagar dispositivos automáticamente en caso de falla"
                ],
                "Tu casa trabaja por ti. No importa si estás de viaje, en la oficina o simplemente descansando."
            ]
        }

    ],
    en: [
        {
            seccion1: [
                "Keep Your Home Online. Always. Anywhere.",
                "With our smart plug, you can restart and control key devices anytime, from anywhere.",
                "What can you control?",
                [
                    "Security cameras: Make sure they’re always on.",
                    "Air conditioning: Avoid failures and stay in control remotely.",
                    "Wi-Fi: Restart your network in seconds, without moving.",
                    "Lights and lamps: Simulate presence when you're away."
                ]
            ],
            seccion2: [
                "How does it work?",
                "Just connect your devices to the smart plug. With the app, you can:",
                [
                    "Monitor your internet connection",
                    "Ensure cameras stay online",
                    "Track temperature and humidity",
                    "Get alerts if something fails",
                    "Schedule automatic restarts",
                    "Turn devices on/off during failures"
                ],
                "Let your home work for you — no matter where you are."
            ]
        }

    ]
}
function Servicios_diseño() {
    const { language, handleLanguage } = useContext(LanguageContext);
    let info = textos[language];
    let seccion1 = info[0].seccion1;
    let seccion2 = info[0].seccion2;

    useEffect(() => {

    }, []);
    return (
        <div

        >

            <div className="card-detalle card-detalle-s">
                <div className='text1'>
                    <div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '20px', marginBottom: '20px' }}>{seccion1[0]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'normal', color: '#63656A', fontSize: '15px', marginBottom: '20px' }}>{seccion1[1]}</div>
                        <div style={{ fontWeight: 'bold', color: '#004A88', fontSize: '20px', marginTop: '20px', marginBottom: '10px', fontSize: '15px' }}>{seccion1[2]}</div>
                        <div>
                            {
                                seccion1[3].map(item => {
                                    return (
                                        <>
                                            <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'square', borderTop: 'solid 1px #63656A', padding: '20px' }}>
                                                <span style={{fontWeight: 'bold'}}>{item.split(':')[0]}: </span>
                                                {item.split(':')[1]}
                                            </li>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='img1 im1-s'>
                    <div className="img-keepRunning1"></div>
                </div>
            </div>
            <div className="card-detalle card-detalle-s">

                <div className='img1' style={{ marginLeft: '0', paddingRight: '20px' }}>
                    <div className="img-keepRunning2"></div>
                </div>
                <div className='text1'>
                    <div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#004A88', fontSize: '20px', marginBottom: '20px' }}>{seccion2[0]}</div>
                        <div style={{ background: 'transparent', color: '#4D4D4D', fontSize: '15px', marginBottom: '20px' }}>{seccion2[1]}</div>
                        <div>
                            {
                                seccion2[2].map((item, index) => {
                                    return (
                                        <>
                                            <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'square', borderTop: 'solid 1px #63656A', padding: '20px', listStyle:' none', }}>
                                                <img src={iconos[index]} style={{marginRight: '20px'}}/>    {item}
                                            </li>
                                        </>
                                    )
                                })
                            }
                        </div>
                        <div style={{ fontWeight: 'bold', color: '#4D4D4D', fontSize: '20px', marginTop: '20px', marginBottom: '10px', fontSize: '15px' }}>{seccion2[3]}</div>            
                        <div className="img-keepRunning2-r"></div>            
                    </div>
                    {/* <div className="img-keepRunning2"></div> */}
                </div>
                
            </div>
        </div>
    )
}

export default Servicios_diseño;